export default __webpack_public_path__ + "static/media/di3.773bb8b3.jpg";